// extracted by mini-css-extract-plugin
export default {"root":"Navbar_root__XHgC9","menuWrapper":"Navbar_menuWrapper__SIpI6","titleWrapper":"Navbar_titleWrapper__QCOeP","accountWrapper":"Navbar_accountWrapper__JLhgG"};